module.exports = "https://de18y2hs3hlxs.cloudfront.net/04bbf00c-82ab-4e06-8439-4302b170a242/images/doctors.png?f2c36e418b5725f34aa32f105b6d7e41";